export default "__VITE_ASSET__IWj1VYaF__"